<template>
  <el-form
    :model="form"
    ref="form"
    status-icon
    label-width="150px"
    size="medium"
    class="demo-form"
    :rules="rules"
    label-position="top"
    v-loading="loading"
  >
    <el-form-item label="Nombre" prop="name">
      <el-input
        v-model="form.name"
        autocomplete="off"
        placeholder="Nombre de la categoría"
        clearable
      ></el-input>
    </el-form-item>
    
    <el-form-item>
      <el-button
        type="primary"
        @click="submitForm('form')"
        :loading="loading"
        icon="el-icon-check"
      >Guardar</el-button>
      <!-- <el-button @click="resetForm('form')" icon="el-icon-close">Cancelar</el-button> -->
    </el-form-item>
  </el-form>
</template>
<script>
import { save } from "@/api/administration/category.js";
export default {
  data() {
    return {
      loading: false,
      form: {
        id: "",
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Campo obligatorio",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveForm();
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveForm() {
      save(this.form.name)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.resetForm("form");
            this.$emit('success', data.data)
          } else {
            this.$message.error("Error! " + data.error.errorInfo[2]);
          }
        })
        .catch(function (error) {
          this.loading = false;
          console.log("Err: ", error);
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.loading = false;
      this.edit = false;
    },
  }
}
</script>